import { render, staticRenderFns } from "./DialogProduct.vue?vue&type=template&id=bc79c6b2&scoped=true&"
import script from "./DialogProduct.vue?vue&type=script&lang=js&"
export * from "./DialogProduct.vue?vue&type=script&lang=js&"
import style0 from "./DialogProduct.vue?vue&type=style&index=0&id=bc79c6b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc79c6b2",
  null
  
)

export default component.exports